import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useHistory, useParams } from 'react-router-dom'
import { Form, Formik } from 'formik'
import * as auth from '../redux/actions'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import FormPassword from 'src/cms/helpers/components/forms/FormPassword'
import { useEffect, useRef, useState } from 'react'
import { isEmpty } from 'lodash'
import { NewPassword } from './NewPassword'
import { IAuthState } from '..'
import { ISettingTypeState } from '../../siteSettings/components/settings'
import OTPTimer from './OtpTimer'

import { Turnstile, useTurnstile } from "react-turnstile";


const loginSchema = Yup.object().shape({
  // email: Yup.string()
  //   .email('Wrong email format')
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 5 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const verifyUserSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function Login() {
  const dispatch = useDispatch()
  const turnstile = useTurnstile();
  const history = useHistory()
  const params: { id: string } = useParams()
  const authResp: IAuthState = useSelector((state: any) => state.auth)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const [tokenCaptcha, setTokenCaptcha] = useState<string | null>(null);
  const loading = authResp?.loading
  const [userId, setUserId] = useState(authResp?.userId)
  const [applicationCredentials, setApplicationCredentials] = useState([])
  const [smtpSetting, setSmtpSetting] = useState([])
  const [loginState, setLoginState] = useState('verifyUser')
  const [userState, setUserState] = useState('otp_verify')
  const [currentEmail, setCurrentEmail] = useState('')
  const [failedAttempts, setFailedAttempts] = useState(() =>
    parseInt(sessionStorage.getItem('loginFailedAttempts') || '0', 10)
  )
  const prevLoadingRef = useRef(loading)

  useEffect(() => {
    let arrayOfCredentials: any = []
    let smtpSet: any = []
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Application Credentials']?.map((item: any) => {
          arrayOfCredentials.push(item)
        })
      settingTypeData?.backendData &&
        settingTypeData?.backendData['SMTP Settings']?.map((item: any) => {
          smtpSet.push(item)
        })
    }
    setApplicationCredentials(arrayOfCredentials)
    setSmtpSetting(smtpSet)
  }, [settingTypeData])


  useEffect(() => {
    applicationCredentials?.map((items: any) => {
      if (items.name === 'loginByEmail') {
        if (items.value === '1') setLoginState('loginByEmail')
      }
      if (items.name === 'loginByPhoneNumber') {
        if (items.value === '1') setLoginState('loginByPhoneNumber')
      }
      if (items.name === 'loginByUsername') {
        if (items.value === '1') setLoginState('loginByUsername')
      }

      if (items.name === 'loginByEmail' && items.value === '1') {
        if (items.name === 'loginByPhoneNumber' && items.value === '1') {
        }
      }
      // if (items.name === 'loginByEmail') {
      //   if (items.value === '1') setLoginState('loginByEmail')
      // }
      // if (items.name === 'loginByEmail') {
      //   if (items.value === '1') setLoginState('loginByEmail')
      // }
      // if (items.name === 'loginByEmail') {
      //   if (items.value === '1') setLoginState('loginByEmail')
      // }
      // if (items.name === 'loginByEmail') {
      //   if (items.value === '1') setLoginState('loginByEmail')
      // }
      // if (
      //   items.name === 'loginByEmail' &&
      //   items.value === '1' &&
      //   items.name === 'loginByPhoneNumber' &&
      //   items.value === '1'
      // ) {
      //   setLoginState('loginByEmail&PhoneNumber')
      // }
      // if (
      //   items.name === 'loginByEmail' &&
      //   items.value === '1' &&
      //   items.name === 'loginByUsername' &&
      //   items.value === '1'
      // ) {
      //   setLoginState('loginByEmail&Username')
      // }

      // if (
      //   items.name === 'loginByPhoneNumber' &&
      //   items.value === '1' &&
      //   items.name === 'loginByUsername' &&
      //   items.value === '1'
      // ) {
      //   setLoginState('loginByPhone&Username')
      // }

      // if (
      //   items.name === 'loginByEmail' &&
      //   items.value === '1' &&
      //   items.name === 'loginByUsername' &&
      //   items.value === '1' &&
      //   items.name === 'loginByPhoneNumber' &&
      //   items.value === '1'
      // ) {
      //   setLoginState('loginByEmail&Username&PhoneNumber')
      // }
    })
  }, [applicationCredentials])

  useEffect(() => {
    if (!authResp.firstLogin && !isEmpty(authResp?.data)) {
      setLoginState('loginUser')
    }
    if (authResp.firstLogin && !isEmpty(authResp?.data)) {
      setLoginState('verifyChangeNewPassword')
    }

    if (authResp?.setNewPasswordSuccess) {
      setLoginState('loginUser')
    }

    if (authResp?.userId) {
      setUserId(authResp?.userId)
    }
  }, [authResp])

  const [timer, setTimer] = useState(2)

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['SMTP Settings']?.map((item: any) => {
          if (item?.name === 'otpResendTime') {
            let data = item?.value
            setTimer(data)
          }
        })

      const TwoFA = settingTypeData?.backendData &&
        settingTypeData?.backendData['SMTP Settings']?.some((item: any) => item.name === 'twofaSetting' && item.value === '1')


      const TwoFAMail = settingTypeData?.backendData &&
        settingTypeData?.backendData['SMTP Settings']?.some((item: any) => item.name === "twoFaMailSetting" && item.value === '1')

      setUserState(TwoFA && TwoFAMail ? 'otp_verify' : "verify_user")
    }
  }, [timer, settingTypeData])

  useEffect(() => {
    if (!isEmpty(params?.id)) {
      setUserId(params?.id)
      setLoginState('verifyChangeNewPassword')
    }
  }, [params])

  useEffect(() => {
    if (authResp?.is2FALogin && currentEmail) {
      history.push({ pathname: '/auth/verify-otp', state: { email: currentEmail } })
    }
  }, [authResp?.is2FALogin, currentEmail])

  // Track failed login attempts to show Turnstile after 2 failures
  useEffect(() => {
    if (prevLoadingRef.current && !loading) {
      if (authResp?.accessToken) {
        // Login succeeded — reset counter
        setFailedAttempts(0)
        sessionStorage.removeItem('loginFailedAttempts')
        setTokenCaptcha(null)

      } else {
        // Login failed — increment counter
        setFailedAttempts((prev) => {
          const next = prev + 1
          sessionStorage.setItem('loginFailedAttempts', String(next))
          turnstile && turnstile.reset()
          return next
        })
        // setTokenCaptcha(null)
      }
    }
    prevLoadingRef.current = loading
  }, [loading, authResp?.accessToken])

  return (
    <>
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={loginSchema}
        validateOnChange
        onSubmit={async (values: { [key: string]: string }, { setSubmitting }) => {
          console.log(tokenCaptcha)
          // if (userState === 'otp_verify') {
          //   // history.push({ pathname: '/auth/verify-otp', state: { email: currentEmail } })
          //   // dispatch(auth.actions.checkFirstTimeLogin(values.email))
          //   // } else if (loginState === 'verifyChangeNewPassword') {
          //   //   dispatch(auth.actions.setPassword(userId, values.password, values.confirmPassword))
          // } else {
          if (failedAttempts >= 2 && !tokenCaptcha) {
            alert("Please complete the captcha!");
            setSubmitting(false);
            return;
          }

          dispatch(auth.actions.login(values.email, values.password));
          setCurrentEmail(values.email)



          // }
        }}
      >
        {({ isSubmitting, isValidating, touched, handleChange, errors }) => {
          return (
            <Form>
              <div className='pt-8'>
                <div className=''>
                  {/* {(loginState === 'verifyUser' || loginState === 'loginUser') && ( */}
                  <>
                    <h4
                      className='login-box-msg text-center mt-10 mb-5'
                      data-cy='login-box-message'
                    >
                      Log in to start your session
                    </h4>

                    <FormTextBox
                      labelClassName='col-md-12'
                      containerClassName='col-md-12'
                      // type='email'
                      placeholder='Email'
                      name='email'
                      label='Email'
                      onChange={handleChange}
                      validate={isValidating}
                      errors={errors}
                      touched={touched}
                      required={true}
                      data-cy='login-email-field'
                    />

                    <FormPassword
                      labelClassName='col-md-12'
                      containerClassName='col-md-12'
                      placeholder='Password'
                      label='Password'
                      name='password'
                      onChange={handleChange}
                      validate={isValidating}
                      errors={errors}
                      touched={touched}
                      required={true}
                      data-cy='login-password-field'
                    />
                    {failedAttempts >= 2 && (
                      <>
                        {/*  <Turnstile */}
                        {/* siteKey="0x4AAAAAACXea3_oQKF99_lt" */}
                        {/* // // onSuccess={(token: any) => setTokenCaptcha(token as string)}
                        // /> */}

                        <Turnstile
                          sitekey="0x4AAAAAACXea3_oQKF99_lt"
                          onVerify={(token) => {
                            setTokenCaptcha(token)
                          }}
                        />
                      </>
                    )}
                  </>
                  {/*  )} */}
                </div>
                {/* {loginState === 'verifyChangeNewPassword' && (
                <NewPassword handleChange={handleChange} touched={touched} errors={errors} />
              )} */}
                <div className='text-center'>
                  <button
                    type='submit'
                    className='btn btn-lg w-100 mb-5'
                    disabled={turnstile ? !tokenCaptcha : loading}
                    data-cy='login-submit-button'
                  >

                    {!loading && (
                      <span className='indicator-label'>
                        Login
                        {/* {loginState === 'verifyUser' ? 'Verify User' : 'Login'} */}
                      </span>
                    )}

                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>

                {/* <button type='button' onClick={() => history.push({ pathname: "/sso" })} className='btn btn-lg w-100 mb-5' disabled={loading} data-cy='login-submit-button'>
                  <span className='indicator-label'>
                    Login With SSO
                  </span>

                </button> */}

                <div className='text-center mb-5'>
                  <Link
                    to='/auth/forgot-password'
                    className='login-link fs-6 fw-bolder'
                    data-cy='login-forgot-password-button'
                  >
                    Forgot Password ?
                  </Link>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik >
    </>
  )
}
